const randomToken = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const normalizeIdempotencyScope = (scope: string): string =>
  String(scope || 'mutation')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9:_-]+/g, '-')
    .slice(0, 48) || 'mutation';

const normalizeIdempotencyParts = (
  parts: Array<string | number | boolean | null | undefined>
): string =>
  parts
    .map((part) => String(part ?? '').trim().toLowerCase().replace(/[^a-z0-9:_-]+/g, '-'))
    .filter(Boolean)
    .join(':')
    .slice(0, 48);

/** Unique-per-call key (includes random suffix). Prefer sticky keys for money retries. */
export const buildIdempotencyKey = (scope: string, parts: Array<string | number | boolean | null | undefined> = []): string => {
  const suffix = randomToken();
  return [normalizeIdempotencyScope(scope), normalizeIdempotencyParts(parts), suffix]
    .filter(Boolean)
    .join(':')
    .slice(0, 128);
};

/**
 * Deterministic key for retry-safe money mutations (mirrors Android CustomerIdempotency).
 * Same scope+parts always yields the same key — no random suffix.
 */
export const buildStickyIdempotencyKey = (
  scope: string,
  parts: Array<string | number | boolean | null | undefined> = []
): string =>
  [normalizeIdempotencyScope(scope), normalizeIdempotencyParts(parts)].filter(Boolean).join(':').slice(0, 128);
